import React, {type FC} from 'react';
import s from './FiltersSubmitButton.scss';
import {
  IProvidedTranslationProps,
  withTranslations,
} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import {useGlobals, withGlobals} from '../../../../../globalPropsContext';
import classNames from 'classnames';
import {Experiments} from '../../../../../constants';

export const FiltersSubmitButtonDataHook = 'filters-submit-button';

const FiltersSubmitButtonComp: FC<IProvidedTranslationProps> = ({t}) => {
  const {
    applyFilteredProductsOnMobile,
    usingExtendedGridGalleryStyles,
    hasFilters,
    hasActiveSortOption,
    useExperiments,
    shouldShowMobile,
    styles,
    stylesParams,
  } = useGlobals();
  const shouldUseMobileButtonsColors =
    useExperiments.enabled(Experiments.GalleryMobileFiltersSettings) &&
    shouldShowMobile &&
    styles.get(stylesParams.responsive);

  const classes = classNames(s.filtersSubmitButton, {
    [s.fullWidthWithFilters]: hasActiveSortOption && hasFilters,
    [s.fullWidthWithoutFilters]: hasActiveSortOption && !hasFilters,
    [s.usingExtendedGridGalleryStyles]: usingExtendedGridGalleryStyles,
    [s.mobileButtonsColors]: shouldUseMobileButtonsColors,
  });

  return (
    <button
      type="button"
      className={classes}
      data-hook={FiltersSubmitButtonDataHook}
      onClick={() => applyFilteredProductsOnMobile()}>
      {t('filtersSubmitButtonText')}
    </button>
  );
};
export const FiltersSubmitButton = withGlobals(withTranslations()(FiltersSubmitButtonComp));
